import React, { useEffect, useState, useContext, useRef } from "react";
import MasteringSongsTable from "../../components/masteringSongsTable";
import ViewLayout from "../../components/viewLayout";
import TableHelper from "../../components/tableHelper";
import { useFetch } from "../../utils/fetchHook";
import { useLocation } from "react-router-dom";
import { getCookie } from "../../jwt/_helpers/cookie";
import { useTranslation } from "react-i18next";
import { StateContext } from "../../utils/context";

const MasteringSongs = props => {
  const token = getCookie("token");
  const {currentUser} = useContext(StateContext);
  const { t } = useTranslation();
  const location = useLocation();
  const masteringID = location.pathname.split("/")[2];
  const [apiData, error, loading] = useFetch("GET",`audio-masterings/${masteringID}/`, token);

  const [tableData, setTableData] = useState([]);


  useEffect(() => {
    if(apiData.songs)
    {
      setTableData(apiData.songs);
    }
  }, [apiData]);

  const tableProps = {
    tableData,
    error,
    loading,
  };

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
          <ViewLayout title={t("mastering.viewSongs.title")}>
            <MasteringSongsTable
              {...tableProps}
            />
          </ViewLayout>
        </div>
      )}
    </>
  );
};

export default MasteringSongs;
